/**
 * True when a required form value is empty.
 * Strings are trimmed; numbers/other types are empty only if nullish (or NaN).
 */
export function isBlank(value) {
    if (value === null || value === undefined) {
        return true;
    }

    if (typeof value === 'string') {
        return value.trim() === '';
    }

    if (typeof value === 'number') {
        return Number.isNaN(value);
    }

    return false;
}
